import {
  ibow2_proto_PortalStaff,
  ibow2_proto_RequestUser,
} from '@/init/swagger';

export const getPortalStaffDisplayName = (staff: ibow2_proto_PortalStaff) => {
  let name = '';
  if (staff.display_family_name) {
    name += staff.display_family_name;
  }
  if (staff.display_first_name) {
    name += ` ${staff.display_first_name}`;
  }
  return name;
};

export const getPortalStaffDisplayNameFurigana = (
  staff: ibow2_proto_PortalStaff,
) => {
  let name = '';
  if (staff.display_family_name_furigana) {
    name += staff.display_family_name_furigana;
  }
  if (staff.display_first_name_furigana) {
    name += ` ${staff.display_first_name_furigana}`;
  }
  return name;
};

export const getRequestUserDisplayName = (user: ibow2_proto_RequestUser) => {
  let name = '';
  if (user.display_last_name) {
    name += user.display_last_name;
  }
  if (user.display_first_name) {
    name += ` ${user.display_first_name}`;
  }
  return name;
};

export const getRequestUserDisplayNameFurigana = (
  user: ibow2_proto_RequestUser,
) => {
  let name = '';
  if (user.display_last_name_furigana) {
    name += user.display_last_name_furigana;
  }
  if (user.display_first_name_furigana) {
    name += ` ${user.display_first_name_furigana}`;
  }
  return name;
};

export const furiganaRegex = /^[ あ-ん゛゜ぁ-ぉゃ-ょー「」、ゔ　]*$/;

export const sanitizedFurigana = (text: string) => {
  const sanitizedValue = text.replace(
    /[^ あ-ん゛゜ぁ-ぉゃ-ょー「」、ゔ　]/g,
    '',
  );
  return sanitizedValue;
};
